import { SET_COMPARE_ADS, UPDATE_COMPARE_ADS, UPDATE_ACCORDION_INDEX, UPDATE_AD_SELECTED_INDEX } from '../constants/ActionTypes';

export function setCompareAds(ads) {
  return { type: SET_COMPARE_ADS, ads };
}

export function updateCompareAd(ad) {
  return { type: UPDATE_COMPARE_ADS, ad };
}

export function updateAdAccordionIndex(moreInfoName, newIndex) {
  return { type: UPDATE_ACCORDION_INDEX, moreInfoName, newIndex }
};

export function updateAdSelectedIndex(moreInfoName, newIndex) {
  return { type: UPDATE_AD_SELECTED_INDEX, moreInfoName, newIndex }
};


// WEBPACK FOOTER //
// ./src/actions/AdActions.js